import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function Input(
  { className, type = 'text', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-surface px-3 py-1 text-sm',
        'placeholder:text-muted-foreground focus-ring',
        'disabled:cursor-not-allowed disabled:opacity-60',
        'transition-[border-color,box-shadow] duration-150 ease-out',
        className,
      )}
      {...rest}
    />
  );
});
